import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import AddressList from './AddressList';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading,
    data,
    error,
    message,
    deletedAddress,
  } = state.address;
  return {
    isLoading,
    data,
    error,
    message,
    deletedAddress,
  };
}

const Styled = withStyles(styles)(AddressList);

export default connect(
  mapStateToProps,
)(Styled);
